/* ぬくくび PDP ------------------------------------------------------------ */
(function () {
  'use strict';

  /* ここから下は商品ページ専用。トップページには .pdp2 が無いので何もしない。
     （動画ヒーローの処理はこのファイルの末尾にある別ブロック） */
  if (!document.querySelector('.pdp2')) return;

  var yen = function (n) { return n.toLocaleString('ja-JP') + '円'; };

  /* --- セールの終了時刻。ここを過ぎたら通常価格に戻す ------------------- */
  /* 実際の Shopify 側の価格も、同じ時刻に戻す予約を必ず入れること。      */
  /* このページを開いてから2時間。1秒ずつ動かす。
     開き直しても伸びないよう、sessionStorage に開始時刻を持たせる。 */
  var WINDOW_MS = 2 * 60 * 60 * 1000;
  var SALE_END = (function () {
    var k = 'kn_sale_end', v = null;
    try { v = sessionStorage.getItem(k); } catch (e) {}
    var end = v ? new Date(+v) : new Date(Date.now() + WINDOW_MS);
    if (!v || isNaN(end) || end - new Date() > WINDOW_MS) {
      end = new Date(Date.now() + WINDOW_MS);
      try { sessionStorage.setItem(k, String(+end)); } catch (e) {}
    }
    return end;
  })();

  var REG  = { 0: 7980, 1: 15960, 2: 23940 };   // セール終了後の価格（＝単品×個数）
  var SALE = { 0: 7980, 1:  7980, 2: 10980 };

  /* 段の呼び名も、セール中と終了後で変える。
     終了後に「1つ購入で1つ無料」のまま値段だけ戻すと、表示が嘘になる。 */
  var NAME = {
    sale: { 0: 'ひとつ',  1: '1つ購入で1つ無料', 2: '2つ購入で1つ無料' },
    reg:  { 0: 'ひとつ',  1: 'ふたつ',           2: 'みっつ' }
  };
  var SUB = {
    sale: { 0: '1個お届け<em>1つあたり 7,980円</em>',
            1: '<b>2個お届け</b><em>1つあたり 3,990円</em>',
            2: '<b>3個お届け</b><em>1つあたり 3,660円</em>' },
    reg:  { 0: '1個お届け<em>1つあたり 7,980円</em>',
            1: '<b>2個お届け</b><em>1つあたり 7,980円</em>',
            2: '<b>3個お届け</b><em>1つあたり 7,980円</em>' }
  };

  /* 買い物かごへ。色と段の組み合わせでバリエーションを引く。 */
  var SHOP = 'jhhbwp-tc.myshopify.com';
  var VARIANTS = null;
  fetch(window.KN_VARIANTS_URL).then(function (r) { return r.json(); })
    .then(function (v) { VARIANTS = v; syncForms(); }).catch(function () {});

  /* バリエーションは色だけ。段は「個数」で表す（Moon Bundle と同じ数え方） */
  function vid() { return (VARIANTS && VARIANTS[state.color]) || null; }
  function cartUrl() {
    var id = vid();
    return id ? 'https://' + SHOP + '/cart/' + id + ':' + QTY[state.tier] : null;
  }
  /* Shopify のテーマに載せた時は、本物の商品フォームの隠し input を書き替える。
     こうすると Shop Pay / Apple Pay などの決済ボタンも、選んだ組み合わせで動く。 */
  /* Moon Bundle の段の中にある色の選択を、ページのスウォッチに合わせる。
     色の正はスウォッチ1つだけにする（widget側の選択欄は style.css で隠してある）。 */
  function syncBundleColor() {
    var sels = document.querySelectorAll('.moonbundleCustomLoader select');
    var n = 0;
    [].forEach.call(sels, function (sel) {
      var ok = [].some.call(sel.options, function (o) { return o.value === state.color; });
      if (!ok || sel.value === state.color) return;
      sel.value = state.color;
      sel.dispatchEvent(new Event('input',  { bubbles: true }));
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      n++;
    });
    return n;
  }

  /* widget で今どの段が選ばれているかを読む。ボタンと下のバーの表示をそれに合わせる。 */
  var TIER_BY_NAME = { 'ひとつ': 0, '1つ購入で1つ無料': 1, '2つ購入で1つ無料': 2 };
  function tierFromBundle() {
    var host = document.querySelector('.moonbundleCustomLoader');
    if (!host) return -1;
    var r = host.querySelector('input[type="radio"]:checked');
    if (!r) return -1;
    var n = r, txt = '';
    for (var i = 0; i < 6 && n; i++) {
      n = n.parentElement;
      if (n && /ひとつ|無料/.test(n.textContent || '')) { txt = n.textContent; break; }
    }
    var hit = -1;
    ['2つ購入で1つ無料', '1つ購入で1つ無料', 'ひとつ'].forEach(function (k) {
      if (hit < 0 && txt.indexOf(k) >= 0) hit = TIER_BY_NAME[k];
    });
    return hit;
  }
  /* 押された段を、その場で読む。widget の中の印は段によって出たり出なかったりするので、
     「押した場所が入っている枠の文字」から決める。3つのうち1つだけ入っている枠を使う。 */
  var TIER_KEYS = ['2つ購入で1つ無料', '1つ購入で1つ無料', 'ひとつ'];
  function tierFromNode(node, stop) {
    var n = node;
    for (var i = 0; i < 8 && n && n !== stop; i++) {
      var txt = n.textContent || '';
      var hits = TIER_KEYS.filter(function (k) { return txt.indexOf(k) >= 0; });
      if (hits.length === 1) return TIER_BY_NAME[hits[0]];
      n = n.parentElement;
    }
    return -1;
  }

  function followBundle() {
    syncBundleColor();
    var t = tierFromBundle();
    if (t >= 0 && t !== state.tier) selectTier(t);
  }

  /* widget は選び直すたびに中身を描き直す。描き直された直後にもう一度そろえる。 */
  (function watchBundle() {
    var host = document.querySelector('.moonbundleCustomLoader');
    if (!host) return;
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(followBundle, 120);
    }).observe(host, { childList: true, subtree: true });

    host.addEventListener('click', function (e) {
      var i = tierFromNode(e.target, host);
      if (i >= 0 && i !== state.tier) setTimeout(function () { selectTier(i); }, 60);
    }, true);
  })();

  function syncForms() {
    var id = vid();
    var inputs = document.querySelectorAll('.kn-form input[name="id"]');
    if (!id || !inputs.length) return false;
    inputs.forEach(function (el) { el.value = id; });
    document.querySelectorAll('.kn-form input[name="quantity"]').forEach(function (el) {
      el.value = QTY[state.tier];
    });
    return true;
  }

  function goCart() {
    if (document.querySelector('.kn-form')) return;   /* フォームがそのまま送信される */
    var u = cartUrl();
    if (u) { window.location.href = u; }
    else { document.getElementById('offer').scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  }

  function onSale() { return new Date() < SALE_END; }

  /* --- カウントダウン ---------------------------------------------------- */
  var promo = document.getElementById('promo');
  /* 秒読みは廃止。開くたびにリセットされる締切は使わない（2026-08-20）。
     上の帯は liquid に書いた文言をそのまま出しっぱなしにする。 */
  function tick() {
    var ms = SALE_END - new Date();
    if (ms <= 0) {
      promo.innerHTML = '<span class="ptx">通常価格でのご案内です</span>';
      applyPrices();
      return;
    }
    var sec = Math.floor(ms / 1000);
    var h = Math.floor(sec / 3600), m = Math.floor(sec % 3600 / 60), ss = sec % 60;
    var p = function (n) { return String(n).padStart(2, '0'); };
    var set = function (id, v) { var e = document.getElementById(id); if (e) e.textContent = v; };
    set('cdh', p(h)); set('cdm', p(m)); set('cds', p(ss));
    setTimeout(tick, 1000);
  }

  /* --- 横に流れる帯。同じ内容を2周ぶん並べて途切れなく回す ------------- */
  (function () {
    var t = document.getElementById('mtrack');
    if (!t) return;
    var items = ['60日間の返金保証付き', '送料無料'];
    /* 隙間なく回すには、画面幅を超えるまで並べてから2周ぶんにする */
    var one = '', n = 0;
    while (n < 8) { one += items.map(function (x) { return '<span>' + x + '</span>'; }).join(''); n += items.length; }
    t.innerHTML = one + one;
  })();

  /* --- オファーの段 ------------------------------------------------------ */
  var state = { tier: 1, color: '黒' };

  function priceOf(i) { return onSale() ? SALE[i] : REG[i]; }

  function applyPrices() {
    var k = onSale() ? 'sale' : 'reg';
    document.querySelectorAll('.tier').forEach(function (el) {
      var i = +el.dataset.i;
      el.querySelector('.pr').textContent = yen(priceOf(i));
      /* 呼び名も差し替える。バッジは残したまま先頭のテキストだけ入れ替える */
      var nm = el.querySelector('.nm');
      if (nm && nm.firstChild) nm.firstChild.textContent = NAME[k][i] + ' ';
      var sub = el.querySelector('.sub');
      if (sub) sub.innerHTML = SUB[k][i];
      var was = el.querySelector('.was');
      if (was) was.style.display = onSale() ? '' : 'none';
      var save = el.querySelector('.save');
      if (save) save.style.display = onSale() ? '' : 'none';
      var tab = el.querySelector('.tab');
      if (tab) tab.style.display = onSale() ? '' : 'none';
    });
    paintCta();
  }

  /* 段を変えたら、上の価格の行も一緒に動かす */
  var QTY  = { 0: 1, 1: 2, 2: 3 };
  var EACH = { 0: '1つあたり 7,980円', 1: '1つあたり 3,990円', 2: '1つあたり 3,660円' };
  var OFF  = { 0: '', 1: '50%OFF', 2: '54%OFF' };
  function paintPrice() {
    var sale = onSale(), i = state.tier;
    var now = document.getElementById('pnow');
    var was = document.getElementById('pwas');
    var off = document.getElementById('poff');
    var ea  = document.getElementById('peach');
    if (!now) return;
    now.textContent = yen(priceOf(i));
    /* 打ち消しは必ず「単品7,980円 × 個数」。他の数字は作らない */
    var reg = 7980 * QTY[i];
    var show = sale && reg > priceOf(i);
    was.textContent = yen(reg);
    was.style.display = show ? '' : 'none';
    off.textContent = OFF[i];
    off.style.display = (show && OFF[i]) ? '' : 'none';
    ea.textContent = (sale ? EACH[i] : '1つあたり 7,980円') + '　・　' + QTY[i] + '個お届け';
  }

  function paintCta() {
    /* トップページには段（.tier）が無いので、その時は何もしない */
    var nmEl = document.querySelector('.tier[data-i="' + state.tier + '"] .nm');
    if (!nmEl || !nmEl.childNodes.length) return;
    var name = nmEl.childNodes[0].textContent.trim();
    var p = yen(priceOf(state.tier));
    paintPrice();
    /* 打ち消しは必ず「単品7,980円 × 個数」。他の数字は作らない */
    var reg = 7980 * QTY[state.tier];
    var strike = (onSale() && reg > priceOf(state.tier))
      ? '<span class="was2">' + yen(reg) + '</span>' : '';
    ['cta', 'ctaB'].forEach(function (b, k) {
      var el = document.getElementById(b);
      if (!el) return;
      el.innerHTML =
        '<span class="l1">👉<span class="np">カートに追加する</span></span>' +
        '<span class="l2"><svg viewBox="0 0 24 24" aria-hidden="true">' +
        '<path d="M12 2l7 3v6c0 4.7-3 8.6-7 10-4-1.4-7-5.3-7-10V5l7-3z"/>' +
        '<path d="M8.5 12.2l2.4 2.4 4.6-4.9"/></svg>' + '<span class="np">' + name + '</span><span class="np">・<span class="nw">60日間</span>の</span><span class="np">返品保証つき</span></span>';
    });
    syncForms();
    document.getElementById('barname').textContent = name;
    document.getElementById('barprice').textContent = p;
    var bb = document.getElementById('barbtn');
    if (bb) bb.innerHTML = '<span id="barprice">' + p + '</span>　カートに追加 →';
  }

  function selectTier(i) {
    state.tier = i;
    document.querySelectorAll('.tier').forEach(function (el) {
      var on = +el.dataset.i === i;
      el.classList.toggle('on', on);
      el.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    paintCta();
  }

  /* 2つ目のオファー枠に、1つ目と同じ中身を複製する */
  var offerB = document.getElementById('offerB');
  if (offerB) offerB.innerHTML = document.getElementById('offer').innerHTML;

  /* Enter / Space でも選べるようにする */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target.closest && e.target.closest('.tier, .sw, .thumbs button');
    if (!t) return;
    e.preventDefault(); t.click();
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest('.tier');
    if (t) selectTier(+t.dataset.i);
    var s = e.target.closest('.sw');
    if (s) {
      state.color = s.dataset.c;
      document.querySelectorAll('.sw').forEach(function (el) {
        var on = el.dataset.c === state.color;
        el.classList.toggle('on', on);
        el.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      document.getElementById('colorname').textContent = state.color;
      /* 下の固定バーの絵だけを選んだ色にする。
         カルーセルは説得の順番そのものなので、色では動かさない。 */
      var FILE = { '黒': 'b-black.jpg', '青': 'b-blue.jpg', 'ピンク': 'b-pink.jpg' };
      var bi = document.getElementById('barimg');
      if (bi && bi.dataset.base) bi.src = bi.dataset.base.replace('b-black.jpg', (FILE[state.color] || 'b-black.jpg'));
      syncBundleColor();
      var bc = document.getElementById('barcolor'); if (bc) bc.textContent = state.color;
    }
    /* 下の固定バーは「カートに追加」。フォームが無い時だけオファーの段に戻す。 */
    if (e.target.closest('#barbtn')) {
      e.preventDefault();
      /* 固定バーは「カートに追加」。本物のフォームがあればそれを送る。 */
      var mainCta = document.getElementById('cta');
      if (mainCta && mainCta.closest('form')) { mainCta.click(); return; }
      var tgt = document.getElementById('offer');
      if (tgt) {
        tgt.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var best = document.querySelector('#offer .tier:last-child');
        if (best) {
          best.classList.add('flash');
          setTimeout(function () { best.classList.remove('flash'); }, 1400);
        }
      }
      return;
    }
    var buy = e.target.closest('#cta') || e.target.closest('#ctaB');
    if (buy) {
      if (buy.closest('.kn-form')) { syncForms(); return; }   /* 本物のフォームに任せる */
      e.preventDefault(); goCart();
    }
  });

  /* --- ギャラリー（横スワイプ。サムネ・番号・見出しを同期させる） ------- */
  var grail = document.getElementById('grail');
  var thumbs = document.getElementById('thumbs');
  var gnow = document.getElementById('gnow');
  var gcap = document.getElementById('gcap');
  var gdots = document.getElementById('gdots');
  var tbtn = thumbs ? [].slice.call(thumbs.querySelectorAll('button')) : [];
  var gsl = grail ? [].slice.call(grail.querySelectorAll('.gslide')) : [];
  var gdot = gdots ? [].slice.call(gdots.querySelectorAll('i')) : [];
  var gcount = gsl.length || tbtn.length;

  function paintGallery(i) {
    tbtn.forEach(function (b, k) {
      var on = k === i;
      b.classList.toggle('on', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    gdot.forEach(function (d, k) { d.classList.toggle('on', k === i); });
    if (gnow) gnow.textContent = i + 1;
    if (gcap && tbtn[i]) gcap.textContent = tbtn[i].dataset.cap || '';
  }

  function gIndex() {
    if (!grail || !gsl.length) return 0;
    var x = grail.scrollLeft, best = 0, bd = Infinity;
    for (var k = 0; k < gsl.length; k++) {
      var d = Math.abs(gsl[k].offsetLeft - grail.offsetLeft - x);
      if (d < bd) { bd = d; best = k; }
    }
    return best;
  }

  if (grail) {
    var gt = null;
    grail.addEventListener('scroll', function () {
      clearTimeout(gt);
      gt = setTimeout(function () { paintGallery(gIndex()); }, 60);
    }, { passive: true });
  }
  function goSlide(i) {
    i = Math.max(0, Math.min(gcount - 1, i));
    if (grail && gsl[i]) grail.scrollTo({ left: gsl[i].offsetLeft - grail.offsetLeft, behavior: 'smooth' });
    paintGallery(i);
  }
  ['gprev', 'gnext'].forEach(function (id, k) {
    var b = document.getElementById(id);
    if (b) b.addEventListener('click', function () {
      goSlide(gIndex() + (k ? 1 : -1));
    });
  });
  if (thumbs) {
    thumbs.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b || !grail) return;
      var i = +b.dataset.i;
      grail.scrollTo({ left: grail.clientWidth * i, behavior: 'smooth' });
      paintGallery(i);
    });
  }

  /* --- 証言の横スクロール（左右のボタン） -------------------------------- */
  (function () {
    var rail = document.getElementById('rrail');
    if (!rail) return;
    var step = function () {
      var c = rail.querySelector('.rcard');
      return c ? c.offsetWidth + 12 : rail.clientWidth;
    };
    var go = function (dir) { rail.scrollBy({ left: dir * step(), behavior: 'smooth' }); };
    var pv = document.getElementById('rprev'), nx = document.getElementById('rnext');
    if (pv) pv.addEventListener('click', function () { go(-1); });
    if (nx) nx.addEventListener('click', function () { go(1); });
  })();

  /* --- タブ3つ ----------------------------------------------------------- */
  (function () {
    var t = document.getElementById('tabs');
    if (!t) return;
    var btns = [].slice.call(t.querySelectorAll('.tabnav button'));
    var pans = [].slice.call(t.querySelectorAll('.tp'));
    t.addEventListener('click', function (e) {
      var b = e.target.closest('.tabnav button');
      if (!b) return;
      var i = +b.dataset.t;
      btns.forEach(function (x, k) { x.classList.toggle('on', k === i); });
      pans.forEach(function (x, k) { x.classList.toggle('on', k === i); });
    });
  })();

  /* --- 下から出るバー ---------------------------------------------------- */
  var bar = document.getElementById('bar');
  var anchor = document.getElementById('cta');
  /* 買うボタンが画面に入っていない間は、常に下のバーを出す。
     読み込み直後にボタンが折り返しの下にあっても、押せる状態を切らさない。 */
  /* 買う手段が画面に見えている間は、下のバーを出さない。
     出したままだと、再掲したオファーの一番下の段にバーが被る。 */
  /* 下のバーは、買うボタンを通り過ぎたら出しっぱなしにする。
     いつでも買いに戻れる状態を切らさない（2026-08-20）。 */
  function onScroll() {
    var cta = document.getElementById('cta') || document.querySelector('.cta');
    if (!cta) { bar.classList.add('show'); return; }
    var r = cta.getBoundingClientRect();
    bar.classList.toggle('show', r.bottom < 90);
  }
  window.addEventListener('resize', onScroll);
  window.addEventListener('scroll', onScroll, { passive: true });

  applyPrices(); selectTier(1); paintGallery(0); tick(); onScroll();
  setTimeout(followBundle, 1200);
})();

/* ヒーロー動画：iOSは muted をJSでも立てないと自動再生しないことがある */
(function () {
  var v = document.querySelector('.vhero-bg');
  if (!v) return;
  /* PCは横型、スマホは縦型。切り抜きすぎないよう幅で選ぶ */
  if (window.innerWidth >= 750 && v.dataset.wide) {
    v.src = v.dataset.wide;
    if (v.dataset.widePoster) v.poster = v.dataset.widePoster;
    v.load();
  }
  v.muted = true; v.playsInline = true; v.setAttribute('playsinline', '');
  var go = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
  go();
  document.addEventListener('visibilitychange', function () { if (!document.hidden) go(); });
  ['touchstart', 'click'].forEach(function (e) {
    document.addEventListener(e, function once() {
      go(); document.removeEventListener(e, once);
    }, { once: true, passive: true });
  });
})();
